import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import {
  MatDialog
} from '@angular/material/dialog';
// import { GlobalsService } from 'src/app/services/globals/globals.service';

import {
  GlobalsService
} from '../../services/globals/globals.service';

import {
  ChangePasswordDialogComponent
} from '../change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'app-view-profile-dialog',
  templateUrl: './view-profile-dialog.component.html',
  styleUrls: ['./view-profile-dialog.component.scss']
})
export class ViewProfileDialogComponent implements OnInit {

  public breakpoint: number; // Breakpoint observer code
  public fname: string = ``;
  public lname: string = ``;
  public addUserForm: FormGroup;
  public editEnabled: boolean = false;

  wasFormChanged = false;

  nameFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(2)
  ]);

  surnameFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(2)
  ]);

  phoneFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(10)
  ]);

  emailFormControl: FormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  constructor(
    public globals: GlobalsService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {}

  public ngOnInit(): void {

    this.addUserForm = this.fb.group({
      IdProof: null,
      firstname: [this.globals.activeUser.name ? this.globals.activeUser.name : "", [Validators.required, Validators.pattern('[a-zA-Z]+([a-zA-Z ]+)*')]],
      lastname: [this.globals.activeUser.surname ? this.globals.activeUser.surname : "", [Validators.required, Validators.pattern('[a-zA-Z]+([a-zA-Z ]+)*')]],
      email: [this.globals.activeUser.email ? this.globals.activeUser.email : "", [Validators.required, Validators.email]],
    });

    this.nameFormControl.setValue(this.globals.activeUser.name ? this.globals.activeUser.name : "N/A")
    this.surnameFormControl.setValue(this.globals.activeUser.surname ? this.globals.activeUser.surname : "N/A")
    this.emailFormControl.setValue(this.globals.activeUser.email ? this.globals.activeUser.email : "N/A")
    this.phoneFormControl.setValue(this.globals.activeUser.mobile ? this.globals.activeUser.mobile : "N/A")



    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  public onAddUser(): void {
    this.markAsDirty(this.addUserForm);
  }

  openDialog(): void {
    if (this.addUserForm.dirty) {
      // const dialogRef = this.dialog.open(DeleteComponent, {
      //   width: '340px',
      // });
    } else {
      this.dialog.closeAll();
    }
  }

  onNoClick() {
    this.dialog.closeAll();
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

  toggleEdit() {

    if (this.editEnabled) {
      //TODO: Save -- USE await

    }
    //Toggle
    this.editEnabled = !this.editEnabled;
  }

  changePassword() {

    // console.log(11)
    this.dialog.closeAll()

    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      width: '640px',
      disableClose: false,
      backdropClass: "bdrop"
    });
  }

}
